import { useRecoilCallback, useRecoilValue } from "recoil";
import { AuthScreenAtom } from "../../state/authAtoms";
import { ShowTourSelectionAtom } from "../../state/uiAtoms";

import { text } from "@quickpoint.me/shared";
import { useStartTour } from "../../hooks/useStartTour";
import { IsInPortrait } from "../../state/selectors";
import { TermsOfService } from "./register/SignUp";
import { AuthPillButton, Banner } from "./styled/Components";
import { StyledInput } from "./styled/StyledInput";

export function LoginOrSignUp() {
	const isInPortrait = useRecoilValue(IsInPortrait);
	const login = useRecoilCallback(({ set }) => () => {
		set(AuthScreenAtom, "loginChoices");
	});
	const signMeUp = useRecoilCallback(({ set }) => () => {
		set(AuthScreenAtom, "signUp");
	});

	const startTour = useStartTour();
	const openTourSelection = useRecoilCallback(
		({ set }) =>
			() => {
				if (isInPortrait) {
					// portrait has exactly one tour (mobile) — start it directly
					startTour("mobile");
					return;
				}
				set(ShowTourSelectionAtom, true);
			},
		[isInPortrait, startTour],
	);

	return (
		<StyledInput $isInPortrait={isInPortrait}>
			<Banner />
			<div className="buttons">
				<AuthPillButton data-testid="login-button" onClick={() => login()}>
					{text.auth.login}
				</AuthPillButton>
				<AuthPillButton $variant="primaryOutline" onClick={() => signMeUp()}>
					{text.auth.signUp}
				</AuthPillButton>
				<AuthPillButton
					$variant="primaryOutline"
					onClick={() => openTourSelection()}
				>
					{text.auth.tour}
				</AuthPillButton>
				<TermsOfService />
			</div>
		</StyledInput>
	);
}
